module.exports = __webpack_public_path__ + "static/media/girl-at-desk.87598971.svg";